export default {
  methods: {
    showLoader(){
      this.$store.commit('loader', true)
    },
    hideLoader(){
      this.$store.commit('loader', false)
    },
    websiteLink(url){
      //todo - domain to config
      return `https://tecknael.se/${url}`
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/mixins/GlobalMixin.js